// extracted by mini-css-extract-plugin
export default {"wrapper":"mCudTyRGpe","title":"mOvHQiNlsD","dark":"nE0N4IRIP1"};